<div cpFileUpload class="uploader" (fileDrop)="uploadFiles($event)" (click)="showFileBrowser()"
     [class.mod-errors]="validate && hasErrors" [class.mod-uploads]="hasUploads">
  <div class="title">{{uploadTitle | translate}}</div>

  <input #fileInput class="file-input" type="file" (change)="onFilesChosen($event)" multiple />

  <div *ngIf="!hasUploads; else showUploads" data-icon="&#xe007;" class="message" [innerHtml]="uploadMessage | translate">
  </div>

  <ng-template #showUploads>
    <div class="uploads">
      <cp-file-progress *ngFor="let file of service.files" [file]="file" (remove)="removeFile($event)">
      </cp-file-progress>
    </div>
  </ng-template>
</div>

<cp-validation-error [errors]="errorMessage" [validate]="validate"></cp-validation-error>
